import { useRef, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useMediaQuery } from "react-responsive";

export function Profile() {
  const [textMinimized, setTextMinimized] = useState(true);
  const rowRef = useRef<HTMLDivElement | null>(null);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 480px)" });

  const toggleTextExpansion = () => {
    setTextMinimized(!textMinimized);
    if (!textMinimized) {
      if (rowRef.current) {
        rowRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <div>
      <Container
        className="padding-sm margin-inline-sm rounded bg-color-4"
        fluid
      >
        <Row
          className="grid grid-col-repeat-auto align-items-center justify-center padding-sm"
          ref={rowRef}
        >
          <Col className="flex align-items-center justify-center flex-shrink-2">
            <LazyLoadImage
              src={`${process.env.PUBLIC_URL}/images/gamecontroller-svgrepo-com.svg`}
              alt=""
              className="img-icon"
            ></LazyLoadImage>
          </Col>
          <Col className="flex align-items-center justify-center">
            <h1 className="padding-md section-title">Profile</h1>
          </Col>
        </Row>
        <hr></hr>
        <Row
          className={`${!isTabletOrMobile && "overflow-y-hidden"} padding-md ${
            textMinimized
              ? "profile_section_minimized"
              : "profile_section_expanded"
          }`}
          id="profileTextRow"
        >
          {!isTabletOrMobile ? (
            <>
              <Col className="flex justify-start align-items-center flex-d-col width-100">
                <Button id="expandAboutMe" onClick={toggleTextExpansion}>
                  {textMinimized ? "See More" : "See Less"}
                </Button>
                <p
                  id="aboutMe_text"
                  className={`profile_text ${
                    textMinimized ? "minimized" : "expanded"
                  }`}
                >
                  <p>
                    I’m a full-stack developer with a passion for creating
                    software that makes a positive impact. My love for
                    technology began in my childhood playing RuneScape and
                    Adventure Quest, and over the years I’ve turned that
                    enthusiasm into hands-on projects—building computers, games,
                    websites, and applications with a variety of tools and
                    languages.
                  </p>

                  <p>
                    That foundation led me to my current role as a Junior Full
                    Stack Developer at Great Lakes Solutions. There, I
                    collaborate with a small, agile team to build event-driven
                    Transportation Management, Project and Workflow Management,
                    and CRM systems using .NET Core/.NET Framework MVC and
                    Angular—always striving for seamless continuous integration.
                  </p>

                  <p>
                    Before joining Great Lakes Solutions, I sharpened my skills
                    as a Software Development Intern with the Milwaukee Brewers.
                    During that internship, I built full-stack web applications
                    with React, Tailwind, Express, and SQL Server—and even
                    migrated legacy C# apps to a modern Node.js stack—preparing
                    me to tackle complex production challenges.
                  </p>

                  <p>
                    Those experiences inspired me to explore side projects that
                    blend my passions. Some of my recent work includes:<br></br>
                    • A Twitch-integrated Pokémon Info Community Game Bot built
                    with Node.js and OpenAI to help users research Pokémon stats
                    and strategy.<br></br>• A Milwaukee Brewers Home Run App
                    showcasing my ReactJS, TailwindCSS, Node.js, and Express
                    skills, complete with efficient API caching and dynamic
                    filtering.<br></br>• An upcoming companion site for my
                    Pokémon bot, designed to display real-time spawns and foster
                    user-generated content.
                  </p>

                  <p>
                    Alongside my professional and personal projects, I’ve given
                    back by mentoring at i.c. stars in Kansas City, where I
                    helped aspiring developers launch their first web
                    applications and secure industry placements.
                  </p>

                  <p>
                    Every step of my journey has been self-driven—learning
                    online, building projects while working full-time at Amazon,
                    and constantly exploring new challenges. Although I don’t
                    hold a traditional degree, I bring enthusiasm, creativity,
                    and a relentless curiosity to every team I join.
                  </p>

                  <p>
                    If you’re seeking a versatile, innovative developer who can
                    bridge startup agility with production-grade quality, let’s
                    connect and see how we can build something impactful
                    together.
                  </p>
                </p>
              </Col>
            </>
          ) : (
            <Col className="flex justify-start align-items-center flex-d-col width-100">
              <p id="aboutMe_text" className={`profile_text "minimized" `}>
                <span>
                  I’m a self-taught programmer who learned the ropes through
                  online courses, hands-on projects, all while working full-time
                  at Amazon. I don’t have a college degree, but I have a lot of
                  enthusiasm, curiosity, and creativity. I’m always eager to
                  learn new skills, explore new challenges, and collaborate with
                  others.
                  <br></br> <br></br> If you’re looking for a versatile,
                  innovative, and driven developer to join your team, let’s chat
                  and see how we can work together!
                </span>
              </p>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}
